
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Créer un Site Internet, le guide de A à Z [2026]",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "À l’ère numérique, marquer sa présence en ligne est devenu une étape incontournable pour toute entreprise ou entrepreneur.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Créer un Site Internet, le guide de A à Z [2026]",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "À l’ère numérique, marquer sa présence en ligne est devenu une étape incontournable pour toute entreprise ou entrepreneur.",
        },
      ],
    };
  },
};
